(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    // Prevent 400 error for single variant products
  document.addEventListener('DOMContentLoaded', function() {
    var forms = document.querySelectorAll('form[action="/cart/add"]');
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        var variantInput = form.querySelector('input[name="id"]');
        if (!variantInput || !variantInput.value) {
          e.preventDefault();
          alert('Please select a product option before adding to cart.');
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
